<app-content-header 
    [historyBack]="false"
    (backEvent)="onBack()"
    [headline]="'ai-tariff-select_choose_headline' | i18next">
</app-content-header>

<div class="flex-column h-100 d-flex">
    <div class="row mt-5 g-2 justify-content-center">
        @for (tariff of aiTariffs; track tariff.tariffType) {
            <div [class]="columnClass" class="mb-3 mb-md-0">
                <app-base-price-card
                    [name]="'ai-tariff-select_pascom_ai_tariff_' + aiTariffService.getTariffIdentifier(AITariffType[tariff.tariffType])"
                    [product]="AITariffType[tariff.tariffType]"
                    [prefixOfPrice]="'ai-tariff-select_price_prefix' | i18next"
                    [price]="(tariff.basePrice?.units ?? 0) + (tariff.basePrice?.fractions ?? 0) / 100"
                    timeBilling="ai-tariff-select_price_per_month"
                    [isSelected]="tariff.tariffType === currentPlan?.tariffType"
                    [showSelectButton]="tariff.tariffType !== currentPlan?.tariffType"
                    [buttonText]="'ai-tariff-select_btn_select_ai_tariff_' + aiTariffService.getTariffIdentifier(AITariffType[tariff.tariffType]) | i18next"
                    (selected)="onAITariffSelected($event)">
                    <div class="h3 mx-auto text-danger fw-bold mb-3 mt-4 ">{{ 'ai-tariff-select_body_headline' | i18next }}</div>
                    <div class="d-flex justify-content-center features">
                        <div class="d-flex flex-column align-items-start">
                            <h6 [innerHTML]="'ai-tariff-select_included_minutes' | i18next: { inclusiveMinutes: tariff.includedMinutes }"></h6>
                            <h6 [innerHTML]="'ai-tariff-select_overshoot_minutes' | i18next: { priceOvershootMinute:
                              ( (tariff.overshootPrice?.units ?? 0) + (tariff.overshootPrice?.fractions ?? 0) / 100 ) | localized_currency }"></h6>
                        </div>
                    </div>
                </app-base-price-card>
            </div>
        }
    </div>
    <div class="ml-auto mt-auto p-3 small">{{ 'ai-tariff-select_vat_not_included' | i18next }}</div>
</div>
